module.exports = __webpack_public_path__ + "img/entia-contact-bg-isolated.870f1834.webp";